<div
  *transloco="let t; read: 'remove-tags-dialog'"
  class="xi-modal__container remove-tags__container"
>
  <h2 class="xi-modal__title">{{ t('remove-tags') }}</h2>

  <div class="xi-modal__content remove-tags__content">
    <p>
      {{ options().content }}
    </p>

    <p>
      <mat-form-field class="tags-form" appearance="fill">
        <mat-chip-grid #chipList [aria-label]="t('tags-to-apply')">
          @for (tag of tags; track tag) {
            <mat-chip-row></mat-chip-row>
            <app-lex-xi-tag
              [text]="tag"
              type="document"
              [canUserDelete]="true"
              (onClick)="removeTag(tag)"
            ></app-lex-xi-tag>
          }

          <input
            #input
            [formControl]="chipInput"
            [placeholder]="options().placeholder"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="addTag($event.value, input)"
            (paste)="onTextPasted($event)"
          />

          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="addTag($event.option.value, input)"
          >
            @for (option of filteredChipOptions | async; track option) {
              <mat-option [value]="option">
                {{ option }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-chip-grid>
      </mat-form-field>
    </p>
  </div>

  <div class="xi-modal__actions remove-tags__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

    <xi-default-button
      [text]="t('remove-tags')"
      [disabled]="hasError"
      (onClick)="confirm()"
    ></xi-default-button>
  </div>
</div>
